<template>
  <div class="APP-BOX clearfix">

    <div class="block_02 clearfix">
      <div class="block-n_02 clearfix">
        <form class="tagContenta sia">
          <!--          <div class="div02">-->
          <!--            <input class="input01" type="text" placeholder="客户姓名" v-model="customerName" readonly="readonly">-->
          <!--          </div>-->
          <div>
            <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
            <input class="input01" type="text" v-model="customerName" readonly="readonly">
          </div>
          <div class="div02">
            <select class="select01" v-model="department" @change="getGuideTrent">
              <option value="0">挂号科室(可选)</option>
              <option v-for="depart in departments" :value="depart.id">{{depart.text}}</option>
            </select>
          </div>
          <div class="div02">
            <select class="select01" v-model="guideTrent" @click="guideTrentClick" :disabled="guideTrentDisabled">
              <option value="0">主诉项目(可选)</option>
              <option v-for="trent in guideTrents" :value="trent.id">{{trent.displayName}}</option>
            </select>
          </div>
          <!--          <div class="div02" v-show="employeeShow">-->
          <!--            <input class="input01" type="text" placeholder="我的客管" v-model="employeeName" readonly="readonly">-->
          <!--          </div>-->
          <div v-show="employeeShow">
            <span>我的客管</span>
            <input class="input01" type="text" v-model="employeeName" readonly="readonly">
          </div>
          <a class="a01" @click="createDispatch">确认挂号</a>
        </form>
      </div>

    </div>

    <div class="clear"></div>

    <p class="con">挂号后导医台会收到您的挂号请求<br/>请根据导医台的安排进行就诊</p>
  </div>
</template>

<script>
  import departmentService from '../../services/department-service'
  import {Toast} from 'mint-ui'
  import trentmentService from '../../services/trentment-service'
  import dispatchService from '../../services/dispatch-service'

  export default {
    data () {
      return {
          customerName: this.$store.getters.customerName,
          employeeName: this.$store.getters.employeeName,
          employeeShow: false,
          department: '0',
          departments: [],
          guideTrent: '0',
          guideTrents: [],
          guideTrentDisabled: 'disabled',
          btnDispatchState: 0,
      }
    },
    methods: {
      getGuideTrent () {
        this.guideTrent = '0'
        if (this.department !== '0') {
          const params = {
            deptId: this.department,
          }
          trentmentService.getTrentment(params).then((res) => {
            if (res.statusCode == 200) {
              this.guideTrents = res.data
              this.guideTrentDisabled = false
            } else {
              //console.log(res.message)
              Toast(res.message);
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.guideTrents = []
        }
      },
      guideTrentClick () {
        if (this.department == '0') {
          Toast('请先选择挂号科室')
          return false
        }
      },
      createDispatch () {
        /*if (this.guideTrent == '0') {
          Toast('请先选择主诉科室');
          return false;
        }*/
          if (this.btnRegistState == 1) {
              Toast('请勿重复提交，若等待过长时间，请刷新后尝试');
              return;
          }
        this.btnDispatchState = 1;
        let formData = new FormData();
        formData.append('guideTreatmentId', this.guideTrent);
        dispatchService.createDispatch(formData).then((res) => {
            this.btnDispatchState = 0;
            Toast(res.message);
        }).catch((err) => {
            this.btnDispatchState = 0;
            console.log(err);
        })
      }
    },
    created () {
      if (this.employeeName) {
        this.employeeShow = true
      }
      departmentService.getDepart().then((res) => {
        if (res.statusCode == 200) {
          this.departments = res.data
        } else {
          console.log(res.message)
          Toast('获取挂号科室失败')
        }
      }).catch((err) => {
        console.log(err)
      })

    }
  }
</script>

<style scoped>
  .block-n_02 div {
    border-bottom: 1px solid #e8e8e8;
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    margin-top: 20px;
  }

  .block-n_02 div span {
    width: 20%;
    margin-left: 20px;
  }

  .block-n_02 div input {
    width: 60%;
    border: 0;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    text-indent: 1em;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/customer/Dispatch.vue